export default __webpack_public_path__ + "static/media/left-arrow.eb0772a2.svg";